
define('text!libs/strand/gulp/templates/font_template.html',[],function () { return '<style>\n{{{style}}}\n</style>';});

